import { useState } from "react";
import { Button, type ButtonProps } from "@/shared/components/ui/Button";
import { ConsentManager } from "./ConsentManager";

/**
 * Re-open affordance for the cookie preferences modal. Drop into a footer or
 * the cookie policy page so visitors can revisit their choice after the banner
 * is gone. Accepts Button props so callers can pick the variant/size that fits
 * their context (defaults to a text link).
 */
export function CookieSettingsButton({
  children = "Cookie settings",
  variant = "link",
  ...props
}: ButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant={variant} {...props} onClick={() => setOpen(true)}>
        {children}
      </Button>
      <ConsentManager open={open} onOpenChange={setOpen} />
    </>
  );
}
